/**
 * Store only NON SECURE here as accessing all via window
 * FOR SECURE - use process.env
 * Prefix - REACT_APP
 */
const CONFIG = {
    APP_BASE_URL: process.env.REACT_APP_APP_BASE_URL,
    ENV: process.env.REACT_APP_ENV
  };
  
export default CONFIG;